import { TeamLeadSolutionType, REQUEST_STATUS } from "@src/constants";
import { ProposeSolutionSettings } from "@src/types";

export function getProposeSolutionSettings(
  status?: string
): ProposeSolutionSettings[] {
  return [
    {
      type: TeamLeadSolutionType.PROPOSE_TEAM_MEMBER,
      label: "Propose team member(s)",
      showOption: true,
    },
    {
      type: TeamLeadSolutionType.VACANCY,
      disabled: true,
      label: "Select a vacancy which could cover the project",
      disabledTooltip: "No vacancies available",
      showOption: true,
    },
    {
      type: TeamLeadSolutionType.FORWARD,
      label: "Forward the request to another team lead",
      showOption: true,
    },
    {
      type: TeamLeadSolutionType.IN_RECRUITMENT,
      label: "Mark as 'in recruitment' for all viewers",
      showOption: status !== REQUEST_STATUS.IN_PROGRESS,
    },
    {
      type: TeamLeadSolutionType.DECLINE,
      label: "Decline",
      showOption: status !== REQUEST_STATUS.IN_PROGRESS,
    },
    {
      type: TeamLeadSolutionType.DECLINE_AND_PROPOSE,
      label: "Decline and suggest different workload",
      showOption: status !== REQUEST_STATUS.IN_PROGRESS,
    },
    {
      type: TeamLeadSolutionType.REJECT_FORWARDED_REQUEST,
      label: "Reject (send back to old team lead)",
      showOption: status === REQUEST_STATUS.IN_PROGRESS,
    },
  ];
}
